import clsx from 'clsx'
import {useLayout} from '../../core'
import {Footer} from './Footer'

const FooterWrapper = () => {
  const {config} = useLayout()
  const footerConfig = config.app?.footer

  return (
    <div className='app-footer' id='kt_app_footer'>
      {footerConfig?.containerClass ? (
        <div
          className={clsx(
            'app-container',
            footerConfig.container === 'fixed' ? 'container-xxl' : 'container-fluid',
            footerConfig.containerClass
          )}
        >
          <Footer />
        </div>
      ) : (
        <div className='app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3'>
          <Footer />
        </div>
      )}
    </div>
  )
}

export {FooterWrapper}
